export const languages = [
  {
    id: "Hindi",
    text: "धन्यवाद",
    progress: 100,
  },
  {
    id: "English",
    text: "Thanks",
    progress: 100,
  },
 


]
